import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const store = useStore();
        onMounted(async () => {
            if (localStorage.getItem('token')) {
                store.commit('setHistroyList');
                store.commit('setDrawHistroyList');
                store.commit('setSimpleList');
                store.dispatch('getUserInfo');
                store.dispatch('intelligence/getHistoryList');
                store.dispatch('intelligence/getAllList');
                store.dispatch('getVesion');
                store.commit('setToken', localStorage.getItem('token') || '');
                store.dispatch('getModelList');
            }
            else {
            }
            window.addEventListener('online', updateLineStatus);
            window.addEventListener('offline', updateLineStatus);
        });
        onUnmounted(() => {
            window.removeEventListener('online', updateLineStatus);
            window.removeEventListener('offline', updateLineStatus);
        });
        // 网络状态
        const updateLineStatus = () => {
            store.commit('setLineStatus');
        };
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createBlock(_component_router_view));
        };
    }
});
